import React from "react";
import { observable, action } from "mobx";
import * as Api from "api";
import * as AppGroup from "api/admin/AppGroup";
import * as TrackingVendor from "api/admin/TrackingVendor";

interface Value {
  trackingVendorId?: number;
  id?: number;
  name?: string;
  iosAppId?: string;
  androidAppId?: string;
  regexpCampaign?: string;
  regexpPubTwitter?: string;
}

export class FormStore {
  public errors = new Api.Error<AppGroup.CreateParams>();

  @observable.ref
  public dialog = false;

  @observable.ref
  public trackingVendors: TrackingVendor.IndexResponse[] = [];

  @observable
  public value: Value = {};

  @action.bound
  public modal(dialog: boolean, value?: Value) {
    this.dialog = dialog;
    if (dialog) this.fetchTrackingVendors();
    this.errors.clear();
    this.value = value || {};
  }

  @action.bound
  public async fetchTrackingVendors() {
    const response = await TrackingVendor.Api.index();
    if (response?.status === Api.Status.OK) {
      this.trackingVendors = response.data;
    }
  }

  @action.bound
  public async save(developerId: number) {
    this.errors.clear();

    const params = { developerId, ...this.value };

    const response = this.value.id
      ? await AppGroup.Api.update(this.value.id, params)
      : await AppGroup.Api.create(params);

    if (response?.status === Api.Status.OK) {
      this.modal(false);
      return true;
    }

    this.errors.set(response?.data);

    return false;
  }
}

const Context = React.createContext<FormStore | null>(null);

export const FormStoreProvider: React.FC<{ value?: FormStore }> = ({
  children,
  value,
}) => {
  const store = React.useMemo(() => (value ? value : new FormStore()), [value]);
  return <Context.Provider value={store}>{children}</Context.Provider>;
};

export const useFormStore = () => {
  const formStore = React.useContext(Context);
  if (!formStore) {
    throw new Error("useFormStore must be used within a FormStoreProvider.");
  }
  return formStore;
};
